import Checkbox, {CheckboxProps} from '@fuegokit/react/components/Checkbox'
import styled from 'styled-components'
import sx from '@fuegokit/react/sx'

// literally undo all Checkbox styles, because, well, Atlassian
export const UnstyledCheckbox = styled(Checkbox)<CheckboxProps>`
  appearance: none;
  border-color: unset;
  border-style: unset;
  border-width: unset;
  background-color: unset;
  cursor: unset;
  display: unset;
  height: unset;
  margin: unset;
  margin-top: unset; /* 2px to center align with label (20px line-height) */
  place-content: unset;
  position: unset;
  width: unset;

  &:disabled {
    cursor: unset;
    background-color: unset;
    border-color: unset;
  }

  border-radius: unset;
  transition: unset;

  &::before {
    width: unset;
    height: unset;
    visibility: unset;
    content: unset;
    background-color: unset;
    transition: unset;
    clip-path: unset;
    mask-image: unset;
    mask-size: unset;
    mask-repeat: unset;
    mask-position: unset;

    @media screen and (prefers-reduced-motion: no-preference) {
      animation: unset;
    }
  }
  &:checked,
  &:indeterminate {
    background-color: unset;
    border-color: unset;
    &::before {
      @media screen and (prefers-reduced-motion: no-preference) {
        animation: unset;
      }
    }
  }

  &:checked {
    transition: unset;

    &:before {
      visibility: visible;
      transition: unset;
    }

    &:disabled {
      cursor: not-allowed;
      background-color: unset;
      border-color: unset;
      opacity: unset;

      &:before {
        background-color: unset;
      }
    }

    /* Windows High Contrast mode */
    @media (forced-colors: active) {
      background-color: unset;
      border-color: unset;
    }
  }

  &:indeterminate {
    background: unset;
    &::before {
      mask-image: unset;
      visibility: unset;
    }
  }

  /* fallback :focus state */
  &:focus:not(:disabled) {
    box-shadow: unset;
    outline: unset;
    outline-offset: unset;

    // remove fallback :focus if :focus-visible is supported
    &:not(:focus-visible) {
      outline: unset;
    }
  }

  /* default focus state */
  &:focus-visible:not(:disabled) {
    box-shadow: n unset;
    outline: unset;
    outline-offset: unset;
  }
  ${sx}
`
